module.exports = __webpack_public_path__ + "img/register.c4f9ed03.png";